import React, { FC, useCallback, useState } from 'react';
import ReactSelect from 'react-select';
import { Controller } from 'react-hook-form';
import { useUncontrolledInput } from 'modules/core/hooks';
import { IFormField } from 'modules/core/types/form';

import { selectStyles } from './styles';

export const Select: FC<IFormField> = ({
  placeholder,
  selectProps,
  name,
  options,
  validate,
  rules,
  changeCallback,
}) => {
  const { controlField, errorMessage, hasError } = useUncontrolledInput(name);
  const [currentMenuPlacement, setCurrentMenuPlacement] = useState('');

  const renderSelect = useCallback(
    ({ onChange, name, ref }) => (
      <ReactSelect
        placeholder={placeholder}
        ref={ref}
        name={name}
        styles={selectStyles(!!errorMessage || hasError, currentMenuPlacement, setCurrentMenuPlacement)}
        onChange={(option: any) => {
          onChange(option);
          changeCallback && changeCallback();
        }}
        options={options}
        {...selectProps}
      />
    ),
    [placeholder, errorMessage, hasError, currentMenuPlacement, options, selectProps, changeCallback],
  );

  return (
    <Controller
      name={name}
      render={renderSelect}
      control={controlField}
      defaultValue={undefined}
      rules={{
        ...rules,
        validate,
      }}
    />
  );
};
